import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios'
import MAAYOT_API, { headers } from '../utils/config'
import { logout } from '../redux/actions/userAction'
import { addController } from '../utils/apiAbortManager'

const axiosInstance = axios.create({
  baseURL: MAAYOT_API,
  headers,
})

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('authToken')
    if (!token) {
      logout()
      return Promise.reject(new Error('Authentication token is required.'))
    }
    config.headers.set('Authorization', `Bearer ${token}`)

    const controller = new AbortController()
    config.signal = controller.signal

    addController(controller)

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      if (error.response.status === 401) {
        logout()
      }
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
